import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	ActivityFilter,
	TaskActivitySeriesDTO,
	TaskActivitySingleDTO,
} from '../DTO/task/activity.interface';

export const activityApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getActivityList: builder.query<
			SuccessResponse<Paginated<TaskActivitySeriesDTO>>,
			ActivityFilter
		>({
			query: (body) => ({
				url: `/web/task/activity/series/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['ActivityList'],
		}),
		getActivitySortList: builder.query<
			SuccessResponse<TaskActivitySeriesDTO[]>,
			null
		>({
			query: (body) => ({
				url: `/web/task/activity/series/list`,
				method: 'GET',
			}),
		}),
		sortActivity: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/task/activity/sort`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['ActivityList'],
		}),
		getActivityDetail: builder.query<
			SuccessResponse<TaskActivitySeriesDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/task/activity/series/${id}`,
				method: 'GET',
			}),
			providesTags: ['ActivityDetail'],
		}),
		updateActivityDetail: builder.mutation<
			SuccessResponse<any>,
			TaskActivitySeriesDTO
		>({
			query: (body) => ({
				url: `/web/task/activity/series/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['ActivityDetail'],
		}),
		createActivityDetail: builder.mutation<
			SuccessResponse<any>,
			TaskActivitySeriesDTO
		>({
			query: (body) => ({
				url: `/web/task/activity/series`,
				method: 'POST',
				body,
			}),
		}),
		deleteActivity: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/task/activity/series/${id}`,
				method: 'DELETE',
			}),
		}),
		getActivitySingleList: builder.query<
			SuccessResponse<Paginated<TaskActivitySingleDTO>>,
			ActivityFilter
		>({
			query: (body) => ({
				url: `/web/task/activity/series/${body.id}/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['ActivitySingleList'],
		}),
		createActivitySingleDetail: builder.mutation<
			SuccessResponse<any>,
			TaskActivitySingleDTO
		>({
			query: (body) => ({
				url: `/web/task/activity/series/${body.id}`,
				method: 'POST',
				body,
			}),
		}),
		updateActivitySingleDetail: builder.mutation<
			SuccessResponse<any>,
			TaskActivitySingleDTO
		>({
			query: (body) => ({
				url: `/web/task/activity/single/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['ActivitySingleDetail'],
		}),
		getActivitySingleDetail: builder.query<
			SuccessResponse<TaskActivitySingleDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/task/activity/single/${id}`,
				method: 'GET',
			}),
			providesTags: ['ActivitySingleDetail'],
		}),
		deleteActivitySingle: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/task/activity/single/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['ActivitySingleList'],
		}),
		getActivitySingleSortList: builder.query<
			SuccessResponse<TaskActivitySingleDTO[]>,
			string
		>({
			query: (id) => ({
				url: `/web/task/activity/series/${id}/list`,
				method: 'GET',
			}),
		}),
		sortActivitySingle: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/task/activity/single/sort`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['ActivitySingleList'],
		}),
	}),
});

export const {
	useGetActivityListQuery,
	useGetActivitySortListQuery,
	useSortActivityMutation,
	useGetActivityDetailQuery,
	useUpdateActivityDetailMutation,
	useCreateActivityDetailMutation,
	useDeleteActivityMutation,
	useGetActivitySingleListQuery,
	useCreateActivitySingleDetailMutation,
	useUpdateActivitySingleDetailMutation,
	useGetActivitySingleDetailQuery,
	useDeleteActivitySingleMutation,
	useGetActivitySingleSortListQuery,
	useSortActivitySingleMutation,
} = activityApiSlice;
